
//Site Specific JS
import Configurators from './components/configurators';
import AB1200 from './components/ab-1200-app';
new Configurators();
new AB1200();